// extracted by mini-css-extract-plugin
export default {"container":"Uk-z","bubbleNav":"Vk-z","graphic":"Wk-z","contact":"Xk-z"};